import { Helmet } from "react-helmet";
import "./App.css";
import { initIcons } from "./lib/icons/init-icons";
import AppRoutes from "./lib/router/Router";
import {
  useUserConfigQuery,
  useUserVisualConfigQuery,
} from "./queries/user-query";
initIcons();

function App() {
  useUserConfigQuery();
  const { data } = useUserVisualConfigQuery();

  return (
    <>
      <Helmet>
        <title>
          {data?.company_name
            ? `${data?.company_name}'s Customer Portal`
            : "Growfin - Modern AR Automation Software"}
        </title>
        <link rel="icon" type="image/svg+xml" href={data?.favicon_uri} />
      </Helmet>
      <AppRoutes />
    </>
  );
}

export default App;
